interface InputProps {
  id: string
  name: string
  type?: string
  placeholder?: string
  className?: string
  value?: string
  autoComplete?: string
  inputMode?: string
  autoCapitalize?: string
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function Input({
  id,
  name,
  className = '',
  type = 'text',
  placeholder = '',
  value = '',
  autoComplete = '',
  inputMode = '',
  autoCapitalize = '',
  onInputChange,
}: InputProps) {
  return (
    <input
      autoFocus={true}
      required
      id={id}
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onInputChange}
      autoComplete={autoComplete}
      inputMode={inputMode}
      autoCapitalize={autoCapitalize}
      className={`min-w-0 flex-auto px-3.5 py-2 text-base font-medium placeholder:text-gray-400 rounded-xl ${className}`}
    />
  )
}
